//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import {windVane} from '../../../utils/tmallGenius'
import imgBase64 from '../../../items/imgBase64.vue'
//
export default {
  components: {imgBase64,},
  data() {
    return {
      deviceName: "",
      tips: ""
    };
  },
  beforeRouteEnter(to, from, next) {
    windVane.setNavTitle("添加设备");
    next();
  },
  /*------------------------------------------- 开始运行 -------------------------------------------------------*/
  created() {
    this.deviceName = this.$route.query.name;
    this.tips = {
      xiaofang: "接通电源，长按6秒，直到指示灯红色闪烁",
      xiaoyuan: "接通电源，使用顶针长按按键6秒，直到指示灯红色快闪",
      S30c: "接通电源，长按按钮6秒，直到指示灯红色闪烁",
      S20c: "接通电源，长按按钮6秒，直到指示灯红色闪烁",
      allonePro: "接通电源，长按按钮6秒，直到指示灯红色闪烁",
      wifiLedStrip: "接通电源，长按按键5秒，直到灯带进入绿色呼吸灯状态",
    }[this.deviceName];
  },
  methods: {
    /*------------------------------------------- 绑定函数 -------------------------------------------------------*/
    /*  下一步点击
    * */
    nextStepClick() {
      //跳转
      this.$router.replace({
        path: '/connect/wifi/tips',
        query: {
          name: this.$route.query.name,
        }
      });
    }
  },
};



// WEBPACK FOOTER //
// ./src/pages/connect/wifi/TurnOn.vue